<template>
  <div id="editor-bind-modal">
    <v-dialog
      transition="dialog-top-transition"
      v-model="showModal"
      width="auto"
      :scrim="false"
      :content-class="type"
      persistent="true"
      no-click-animation="false"
    >
      <v-card
        class="card"
      >
        <div class="title">
          {{ title }}
        </div>
        <component
          class="content"
          v-bind:is="component.bind.is"
          v-bind="component.bind"
          v-on="component.on"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "EditorBindModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    showModalProp: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
    }
  },
  created() {},
  watch: {
    showModalProp() {
      this.showModal =  this.showModalProp;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.sector-editor) {
  &.seat {
    .card {
      width: 320px;
    }
  }
  right: 0px !important;
  @media (max-width: 700px) {
    right: unset !important;
    bottom: 0px !important;
  }
  .card {
    width: 300px;
    height: fit-content;
    padding: 0 20px 20px 20px;
    .title {
      text-align: center;
      margin-top: 16px;
      font-size: 22px;
      font-weight: 550;
    }
    .content {
      margin-top: 24px;
    }
  }
}

::v-deep(.multiple-seat-editor) {
  .card {
    width: 400px;
    height: fit-content;
    padding: 0 20px 20px 20px;
    @media (max-width: 700px) {
      width: unset;
    }
    .title {
      text-align: center;
      margin-top: 16px;
      font-size: 22px;
      font-weight: 550;
    }
    .content {
      margin-top: 24px;
    }
  }
}
</style>